<script>
import { mapGetters } from 'vuex'

import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Site Map',
    meta: [{ name: 'description', content: 'Site Map Page.' }],
  },
  components: {
    Layout,
  },
  computed: {
    ...mapGetters('cancellationAndRefund', [
      'contentData',
    ]),
  },
}
</script>

<template>
  <Layout>
    <section class="header-section justify-center" :style="{ backgroundImage: `url(${contentData.image})` }"></section>
    <section class="description-banner-section justify-center">
      <div class="description-container">
        <div class="description-header-container">
          <h1 class="description-title">{{ 'Site Map' }}</h1>
          <h3 class="description-subtitle">{{ 'CoolPass Site Map' }}</h3>
        </div>
        <div class="content-container">
          <ul>
            <router-link tag="li" :to="{ name: 'home' }">CoolPass</router-link>
            <ul class="nested">
              <router-link tag="li" to="/#top-attractions">Top Prague Attractions Included In Coolpass</router-link>
              <router-link tag="li" to="/#coolpass-benefits">Experience Prague & Enjoy Coolpass Benefits</router-link>
              <router-link tag="li" to="/#how-to-use">How To Use Coolpass / Prague Card — Few Easy Steps</router-link>
            </ul>
            <router-link tag="li" :to="{ name: 'attractions' }">Attractions</router-link>
            <ul class="nested">
              <router-link tag="li" to="/attractions#all-attractions">All Attractions</router-link>
              <router-link tag="li" to="/attractions#free-attractions">Attractions With Free Public Entry</router-link>
              <router-link tag="li" to="/attractions#areas">Prague Areas</router-link>
            </ul>
            <router-link tag="li" :to="{ name: 'passAndCard' }">Your Coolpass / Prague Card</router-link>
            <ul class="nested">
              <router-link tag="li" to="/pass-and-card#what-you-get">What You Get With Coolpass / Prague Card</router-link>
              <router-link tag="li" to="/pass-and-card#how-you-save">Saving Money With Coolpass</router-link>
            </ul>
            <router-link tag="li" :to="{ name: 'getYourPass' }">Getting Your Pass</router-link>
            <ul class="nested">
              <router-link tag="li" to="/get-your-pass#prices">Prague Coolpass Prices</router-link>
              <router-link tag="li" to="/get-your-pass#using-coolpass">Prague Coolpass - 4 Easy Steps</router-link>
              <router-link tag="li" to="/get-your-pass#how-to-get">How To Get Prague Card</router-link>
              <router-link tag="li" to="/get-your-pass#sales-points">Sales & Collection Point</router-link>
            </ul>
            <router-link tag="li" :to="{ name: 'planYourTrip' }">Plan Your Trip</router-link>
            <router-link tag="li" :to="{ name: 'news' }">News</router-link>
            <router-link tag="li" :to="{ name: 'faq' }">FAQ</router-link>
            <br>
            <router-link tag="li" :to="{ name: 'reviews' }">Reviews</router-link>
            <router-link tag="li" :to="{ name: 'contactUs' }">Contact Us</router-link>
            <br>
            <router-link tag="li" :to="{ name: 'aboutUs' }">About Us</router-link>
            <router-link tag="li" :to="{ name: 'termsAndConditions' }">Terms & Conditions</router-link>
            <router-link tag="li" :to="{ name: 'cancellationAndRefund' }">Cancellation & Refund</router-link>
            <router-link tag="li" :to="{ name: 'privacyPolicy' }">Privacy Policy</router-link>
          </ul>
        </div>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.header-section {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 550px;
  width: 100%;
}

.description-banner-section {
    margin-top: -335px;

  & .description-container {
    width: 1140px;
    min-height: 600px;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    box-sizing: border-box;
    background: $white;
    box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);
    padding: 15px;

  }
}

.description-header-container {
  width: 100%;
  height: 120px;
  background: $dark-blue;
  padding-top: 9px;
  border-radius: 10px;

  .description-title {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 62px;
    text-transform: uppercase;
    margin-left: 22px;
    color: $white;
  }

  .description-subtitle {
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 22px;
    line-height: 29px;
    margin-left: 25px;
    color: $white;
  }
}

.content-container {
  margin-top: 30px;
  padding: 0 30px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: $black;
}

ul {
  list-style: disc;
}

ul li {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.nested {
  margin-left: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

@media only screen and (max-width: $screen-width-xs) {

  .container {
    width: 100%;
  }

  .header-section {
    height: 244px;
  }

  .description-header-container {
    min-height: 125px;
    height: auto;
    margin-top: -20px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .description-title {
      font-family: Open Sans Bold, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 34px;
      text-transform: uppercase;
      margin: 20px 8px 10px;
      color: $white;
    }

    .description-subtitle {
      font-family: Open Sans Semibold, sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: $white;
      margin: 0 8px;
    }
  }

  .description-banner-section {
    margin: -130px 0 40px;
    & .description-container {
      width: 100%;
      padding: 0;
      box-shadow: none;
    }
  }
}
</style>
